import { render, staticRenderFns } from "./ReferenceListPanel.vue?vue&type=template&id=8fa5b09c"
import script from "./ReferenceListPanel.vue?vue&type=script&lang=js"
export * from "./ReferenceListPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports